import React, { useEffect, useState } from 'react';
import '../../../styles/globals.css'
import { Box, Button, TextField, Typography } from '@mui/material'
import karmaStyles from '../../../styles/KarmaPool.module.css'
import DashboardLogoutFooterComponent from '../footer/DashboardLogoutFooterComponent';
import AdminDashboardMenuHeaderComponent from './header/AdminDashboardMenuHeaderComponent';
import { useKarmaPoolContext } from '../../../state/KarmaPoolContext';
import NoteChoiceComponent from '../social/notes/NoteSubmissionChoiceComponent';
import NewletterNoteSubmissionChoiceComponent from '../social/notes/NewletterNoteSubmissionChoiceComponent';


function LiveNewsletterIdForm(props) {

    const [newsletterIdForm, setNewsletterIdForm] = useState(() => {
        return 1;
    });

    const handleNewsletterIdChange = (event) => {
        setNewsletterIdForm(event.target.value);
    };

    const handleUpdateNewsletterId = () => {
        props.setNewsletterId(newsletterIdForm);
    }

    return (
        <Box sx={{ marginTop: "0.5rem" }}>
            <Typography variant="body2" component="div" gutterBottom>
                <strong> Live Newsletter Id </strong>
            </Typography>
            <Box sx={{ marginTop: "0.5rem", marginBottom: "1.25rem" }} >
                <TextField
                    fullWidth
                    multiline
                    sx={{
                        backgroundColor: "rgba(221, 221, 221, 0.0825)",
                        margin: "0.25rem",
                        width: "18rem",
                        '& textarea': { color: 'white' }, // Update textarea color
                        '& label': { color: 'white' }, // Update label color
                    }}
                    id="newsletterIdForm"
                    placeholder={"1"}
                    onChange={handleNewsletterIdChange}
                    InputLabelProps={{ shrink: false }}
                    value={newsletterIdForm}
                />
            </Box>
            <Box sx={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "0.275rem", marginBottom: "0.25rem" }}>
                <Button
                    type="submit"
                    variant="contained"
                    color="info"
                    onClick={handleUpdateNewsletterId}
                    sx={{ backgroundColor: 'rgba(232, 232, 232, 0.5)', marginTop: "0.0rem", marginBottom: "0.75rem" }}>
                    Update
                </Button>
            </Box>
        </Box>
    );
}

function EditingNewsletterIdForm(props) {

    const [newsletterIdForm, setNewsletterIdForm] = useState(() => {
        return 1;
    });

    const handleNewsletterIdChange = (event) => {
        setNewsletterIdForm(event.target.value);
    };

    const handleUpdateNewsletterId = () => {
        props.setNewsletterId(newsletterIdForm);
    }

    return (
        <Box sx={{ marginTop: "0.5rem" }}>
            <Typography variant="body2" component="div" gutterBottom>
                <strong> Editing Newsletter Id </strong>
            </Typography>
            <Box sx={{ marginTop: "0.5rem", marginBottom: "1.25rem" }} >
                <TextField
                    fullWidth
                    multiline
                    sx={{
                        backgroundColor: "rgba(221, 221, 221, 0.0825)",
                        margin: "0.25rem",
                        width: "18rem",
                        '& textarea': { color: 'white' }, // Update textarea color
                        '& label': { color: 'white' }, // Update label color
                    }}
                    id="newsletterIdForm"
                    placeholder={"1"}
                    onChange={handleNewsletterIdChange}
                    InputLabelProps={{ shrink: false }}
                    value={newsletterIdForm}
                />
            </Box>
            <Box sx={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "0.275rem", marginBottom: "0.25rem" }}>
                <Button
                    type="submit"
                    variant="contained"
                    color="info"
                    onClick={handleUpdateNewsletterId}
                    sx={{ backgroundColor: 'rgba(232, 232, 232, 0.5)', marginTop: "0.0rem", marginBottom: "0.75rem" }}>
                    Update
                </Button>
            </Box>
        </Box>
    );
}

function AdminDashboardNewsletter() {

    function RedirectIfNotLoggedIn() {
        if (window.localStorage.getItem("jwtAuthToken") == null) {
            window.location.href = "/karma";
        }
    }

    const karmaContext = useKarmaPoolContext();

    const [gbpInPool, setGbpInPool] = useState(() => {
        return karmaContext.local.pool.gbpInPool;
    });

    useEffect(() => {
        setGbpInPool(karmaContext.local.pool.gbpInPool);
    }, [karmaContext.local]);

    const handleGbpInPoolChange = (event) => {
        setGbpInPool(event.target.value);
    };

    const handleSubmit = (event) => {
        // Prevent page reload
        event.preventDefault();

        console.log("Setting GBP in pool to: " + gbpInPool);

        fetch(karmaContext.getURLBasePath() + 'pool', {
            method: 'PATCH',
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify({
                "gbpInPool": gbpInPool,
            })
        })
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                karmaContext.refresh();
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    const [newsletterId, setNewsletterId] = useState(() => {
        return 1;
    });

    RedirectIfNotLoggedIn();

    return (
        <>
            <Box className={karmaStyles.homepageBox}>
                <AdminDashboardMenuHeaderComponent
                    newsletterEnabled={true} />
                <Box sx={{ paddingRight: "1.0rem", paddingLeft: "1.0rem", }}>

                    <Box sx={{ marginBottom: "1.25rem" }} />

                    <EditingNewsletterIdForm setNewsletterId={setNewsletterId} />

                    <Box sx={{ marginTop: "2.0rem", marginBottom: "1.25rem" }}>
                        <NewletterNoteSubmissionChoiceComponent newsletterId={newsletterId} />
                    </Box>

                </Box>
            </Box>
            <DashboardLogoutFooterComponent />
        </>
    );
}

export default AdminDashboardNewsletter;
